<template>
  <div class="refuel-container">
    <img class="title" :src="$getImgUrl('/img/activity/refuel/refuel1-title-bg.png')" />
    <div class="info-date text-shadow">活动时间:2022年4月18日-5月31日</div>
    <div class="my-prize" @click="showPrize = true">
      <img :src="$getImgUrl('/img/activity/refuel/refuel1-btn-my-prize.png')" />
    </div>
    <div class="block"></div>
    <div class="swiper-box">
         <van-swipe class="systemMessages" :class="showSystemMessagesList? '':'noSystemMessages'" vertical autoplay='4000' duration='1000' :show-indicators="false" :touchable="false">
        <van-swipe-item class="systemMessagesItem" v-for="(item,index) in systemMessagesList" :key="index">{{ item }}</van-swipe-item>
    </van-swipe>
    </div>

    <div class="refuel-info">
      <div class="refuel-info-item">
        <div class="refuel-info-item-1">
          我的油量：<span class="sp">{{ remaining }}ml</span>
        </div>
        <div class="refuel-info-item-2">
          今日剩余抽奖次数：<span class="sp">{{ lotteryCount }}</span>
        </div>
      </div>
      <div v-if="!isEndDate">
        <img
          v-if="lotteryCount === 0"
          class="lottery-btn"
          :src="$getImgUrl('/img/activity/refuel/refuel1-btn-5.png')"
        />
        <img
          v-else
          @click="gotoWeb()"
          class="lottery-btn"
          :src="$getImgUrl('/img/activity/refuel/refuel1-btn-1.png')"
        />
      </div>
    </div>
    <div class="car-item">
      <img :src="$getImgUrl('/img/activity/refuel/refuel1-item.png')" />
    </div>
    <div class="refuel-btn" v-if="!isEndDate">
      <img
        v-if="isSign !== true"
        @click="goto('/#/signIn')"
        :src="$getImgUrl('/img/activity/refuel/refuel1-btn-2.png')"
      />
      <img v-else :src="$getImgUrl('/img/activity/refuel/refuel1-btn-4.png')" />
      <img
        @click="handleShowShare()"
        :src="$getImgUrl('/img/activity/refuel/refuel1-btn-3.png')"
      />
    </div>
    <div class="btn-gomall" @click="goto('')">
      <img :src="$getImgUrl('/img/activity/refuel/refuel1-btn-mall.png')"/>
    </div>
    <div class="refuel-detail">
      <img :src="$getImgUrl('/img/activity/refuel/refuel1-info.png')" />
    </div>

    <div class="prize-container" v-if="showPrize">
      <div class="prize-box" @click.stop>
        <img
          class="close"
          @click="showPrize = false"
          src="../../../assets/images/new-year/close.png"
        />
        <img class="bg" :src="$getImgUrl('/img/activity/refuel/refuel1-bg-myPrize.png')" />
        <div class="prize-detail">
          <div class="prize-item" v-for="(item, index) of lotteryDetailList" :key="index">
            <div class="item-name">{{ item.itemName }}</div>
            <div :class="item.itemStatus == '已领取' ? 'item-status1' : 'item-status2'">
              {{ item.itemStatus }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-dialog v-model="notWeixinDialog" title="提示" >
      <div class="notWeixin-info">
        请保存二维码微信扫一扫，分享加油。
      </div>
      <img class="qrcode" :src="$getImgUrl('/img/activity/refuel/refuel-qrcode.png')" />
    </van-dialog>

    <!-- <van-overlay :show="showPrize" @click="showPrize = false">
      <div class="prize-dialog test" @click.stop>
        <img
          class="close"
          @click="showPrize = false"
          src="../../../assets/images/new-year/close.png"
        />
        <img
          class="bg"
          :src="$getImgUrl('/img/activity/refuel/refuel1-bg-myPrize.png')"
        />
        <div class="prize-detail">
          <div class="prize-item" v-for="(item, index) of lotteryDetailList" :key="index">
            <div class="item-name">{{ item.itemName }}</div>
            <div :class="item.itemStatus == '已领取' ? 'item-status1' : 'item-status2'">
              {{ item.itemStatus }}
            </div>
          </div>
        </div>
      </div>
    </van-overlay> -->

    <van-overlay :show="showShareImg" @click="showShareImg = false">
      <div class="wrapper" @click.stop>
        <img
          class="close"
          @click="showShareImg = false"
          src="../../../assets/images/new-year/close.png"
        />
        <img class="bg" :src="$getImgUrl('/img/activity/refuel/refuel1-share.png')" />
        <img
          @click="
            showShareImg = false;
            showOverlay = true;
          "
          class="btn"
          :src="$getImgUrl('/img/activity/refuel/refuel1-share-btn-2.png')"
        />
      </div>
    </van-overlay>

    <van-overlay :show="showOverlay" @click="showOverlay = false" z-index="99">
      <div class="overlay-wrapper">
        <div class="text">点击页面右上角分享</div>
        <img class="arrow" src="../../../assets/images/extra-style/arrow.png" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
export default {
  data () {
    return {
      lotteryCount: 0,
      remaining: 0,
      isSign: false,
      lotteryDetailList: [],
      showShareImg: false,
      showOverlay: false,
      showPrize: false,
      clientId: '',
      showSystemMessagesList: false,
      systemMessagesList: [
      ],
      isEndDate: false,
      prizeList: [],
      isWeixin: 'false',
      notWeixinDialog: false
    }
  },
  mounted () {
    this.isWeixin = sessionStorage.getItem('isWeixin') || 'false'

    let dateNow = Date.now()
    this.showSystemMessagesList = !(dateNow < 1650211200000)

    if (dateNow > 1654012800000) {
      this.isEndDate = true
      this.$dialog.alert({ message: '活动已结束，请点击“我的奖品”查看获奖信息！' })
    }

    let userInfo = userUtils.getClientInfo()
    this.clientId = userInfo.clientId
    this.getRefuelInfo()
    this.getLotteryDetailList()
    this.getPrizeList()
    this.initWxJsSdk()
  },
  methods: {
    getRefuelInfo () {
      activityApi.getRefuelInfo().then((res) => {
        if (res.data.resultCode === '0') {
          this.lotteryCount = res.data.resultData.lotteryCount
          this.remaining = res.data.resultData.remaining
          this.isSign = res.data.resultData.isSign
        }
      })
    },
    getLotteryDetailList () {
      activityApi.getLotteryDetailList().then((res) => {
        if (res.data.resultCode === '0') {
          this.lotteryDetailList = res.data.resultData.lotteryDetailList || []
        }
      })
    },
    getPrizeList () {
      activityApi.refuelPrizeList().then((res) => {
        if (res.data.resultCode === '0') {
          this.prizeList = res.data.resultData.prizeList || []
          this.handlePrizeInfo()
        }
      })
    },
    handlePrizeInfo () {
      if (this.prizeList.length !== 0) {
        for (let item of this.prizeList) {
          let clientName = item.clientName
          let hideInfo = ''
          for (let i = 0; i < clientName.length - 2; i++) {
            hideInfo += '*'
          }
          let info = '恭喜' + clientName.charAt(0) + hideInfo + clientName.charAt(clientName.length - 1) + '获得' + item.itemName
          this.systemMessagesList.push(info)
        }
      }
    },
    goto (path) {
      window.location.href = commonUtils.getExtraSite() + path
    },
    gotoWeb () {
      this.$router.push({ name: 'activity-refuel-lottery' })
    },
    handleShowShare () {
      if (this.isWeixin === 'true') {
        this.showShareImg = true
      } else {
        this.notWeixinDialog = true
      }
    },
    initWxJsSdk () {
      // console.log(window.__wxjs_is_wkwebview)
      // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
      console.log('初始化微信jssdk')
      let sdkUrl = null
      const u = navigator.userAgent
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        sdkUrl = global.entryUrl
      }
      const url = `${document.location.origin}/v2/activity/refuel-share-detail?user=${this.clientId}`
      console.log(sdkUrl)

      let imgUrl = this.$getImgUrl() + '/img/activity/refuel/refuel-share-img.png'
      let title = '朋友，请为我加油！'

      console.log(this.$getImgUrl() + '/img/activity/refuel/refuel-share-img.png')

      const appMessageShare = {
        title: title, // 分享标题
        desc: '每天可以加一次，我在博世易加等你！', // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('appMessageShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail')
        }
      }

      const timelineShare = {
        title: title, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () {
          // 用户点击了分享后执行的回调函数
          console.log('timelineShare success' + url)
        },
        fail: function () {
          console.log('appMessageShare fail' + url)
        }
      }
      commonUtils
        .configWxJsSdk(appMessageShare, timelineShare, sdkUrl)
        .then(() => {
          this.wxReady = true
        })
        .catch((error) => {
          this.$emit('error', { errorMsg: error })
        })
    }
  }
}
</script>
<style lang="less" scoped>
.refuel-container {
  background-image: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/refuel/refuel1-bg.png");
  background-size: 100%;
}
.title {
  width: 100%;
}
.my-prize {
  top: 150px;
  position: absolute;
  left: calc(100% - 40px);
  img {
    width: 40px;
  }
}
.car-item {
  width: 100%;
  display: flex;
  flex: 1;
  img {
    flex: 1;
  }
}
.block{
  width: 100%;
  height: 10px;
  background-color: white;
  margin-top: -5px;
}
.refuel-info {
  width: 100vw;
  height: 130px;
  background-image: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/refuel/refuel1-bg-1.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: white;
  display: flex;
  //justify-content: space-around;
  .refuel-info-item {
    margin: 15px 0px 0 30px;
    width: calc(100vw - 130px);
    line-height: 35px;
    text-shadow: 1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white, -1px 1px 0 white,
      1px 0px 0 white, 1px 0px 0 white, -1px 0px 0 white, -1px 0px 0 white,
      0px 1px 0 white, 0px -1px 0 white, 0px -1px 0 white, 0px 1px 0 white;
    .refuel-info-item-1 {
      font-size: 20px;
    }
    .refuel-info-item-2 {
      font-size: 21px;
    }
    .sp {
      font-size: 25px;
      color: red;
    }
  }
  .lottery-btn {
    margin-top: 5px;
    width: 85px;
  }
}
.car-item {
  img {
    width: 100%;
  }
}
.refuel-btn {
  width: 100vw;
  display: flex;
  justify-content: space-evenly;
  img {
    width: 48%;
  }
}
.refuel-detail {
  img {
    width: 100%;
  }
}
.prize-container{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.prize-box {
  margin: 0 5vw;
  width: 90vw;
  padding-top: 100px;
  height: calc(100vh - 100px);
  position: absolute;
  top: 0px;
  left: 5;
  overflow-y: auto;
  overflow-x: hidden;
  .close {
    left: 10px;
  }
  .prize-detail {
    width: calc(100% - 80px - 5vw);
    height: 200px;
    //background-color: red;
    margin: 0 40px;
    position: relative;
    top: -240px;
    overflow-y: auto;
    overflow-x: hidden;
    .prize-item {
      font-size: 18px;
      width: 100%;
      line-height: 38px;
      display: flex;
      justify-content: space-between;
    }
    .item-status1 {
      color: rgb(210, 0, 0);
    }
    .item-status2 {
      color: rgb(11, 98, 63);
    }
  }
}
.prize-dialog {
  margin: 100px 0 0 5vw;
  color: rgb(0, 0, 0);
  .prize-detail {
    width: calc(100% - 80px - 5vw);
    height: 200px;
    //background-color: red;
    margin: 0 40px;
    position: relative;
    top: -240px;
    overflow-y: auto;
    overflow-x: hidden;
    .prize-item {
      font-size: 18px;
      width: 100%;
      line-height: 38px;
      display: flex;
      justify-content: space-between;
    }
    .item-status1 {
      color: rgb(210, 0, 0);
    }
    .item-status2 {
      color: rgb(11, 98, 63);
    }
  }
}
.wrapper {
  margin: 40px 0 0 5vw;
}
.close {
  float: right;
  width: 40px;
}
.bg {
  width: 90vw;
}
.btn {
  position: relative;
  top: -100px;
  left: 20vw;
  width: 50vw;
}
.overlay-wrapper {
  display: flex;
  //align-items: center;
  justify-content: center;
  height: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  display: flex;
  .text {
    margin-top: 70px;
    margin-left: 15px;
  }
  .arrow {
    //position: absolute;
    top: 0;
    padding-left: 10px;
    width: 80px;
    height: 80px;
  }
}
.btn-gomall{
  width: 60%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 10px;
  img{
    width: 100%;
  }
}
.info-date{
  width: 100%;
  font-size: 16px;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 173px;
}
.text-shadow{
  text-shadow: 1px 1px 0 white, 1px -1px 0 white, -1px -1px 0 white, -1px 1px 0 white,
      1px 0px 0 white, 1px 0px 0 white, -1px 0px 0 white, -1px 0px 0 white,
      0px 1px 0 white, 0px -1px 0 white, 0px -1px 0 white, 0px 1px 0 white;
}
.swiper-box{
  width: 100%;
  background-color: white;
}
  .systemMessages {
    //border: solid 1px  ;
    background-color: rgba(167, 217, 201, 0.5);
    height: 30px;
    line-height: 30px;
    width: 96%;
    margin:0 auto;
    text-align: center;
    color: #000000;
    border-radius:15px;
    .systemMessages-item{
        height: 25px;
        line-height: 25px;
    }
  }
  .noSystemMessages{
    display: none;
  }
  .qrcode{
    width: 160px;
    margin-left: 80px;
  }
  .notWeixin-info{
    width: 320px;
    text-align: center;
    line-height: 30px;
    font-weight: 700;
  }
</style>
